import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'react-emotion';

import endIcon from '../assets/img/daodi_lishi_icon@3x.png';
import loadingIcon from '../assets/img/jiazai_lishi_icon@3x.png';

const Card = styled.div`
  position: relative;
  width: 100%;
  height: 108px;
  text-align: center;
  background-color: #f2f2f2;
`;

const Container = styled.span`
  margin: 35px auto auto auto;
  display: inline-block;
`;

const Icon = styled.img`
  vertical-align: middle;
  width: 40px;
  height: 40px;
`;

const SpinAnimation = keyframes`
  from {transform:rotate(0deg);}
  to {transform:rotate(360deg);}
`;

const Spin = styled(Icon)`
  animation: ${SpinAnimation} 1s ease infinite;
`;

const Text = styled.span`
  display: inline-block;
  vertical-align: middle;
  color: rgb(219, 219, 219);
  font-size: 20px;
  margin: 0;
  margin-left: 18px;
`;

const FooterItem = ({ loading }) => (
  <Card>
    <Container>
      { loading ? <Spin src={loadingIcon} /> : <Icon src={endIcon} /> }
      <Text>{ loading ? '努力加载中' : '到底啦！！！' }</Text>
    </Container>
  </Card>
);

FooterItem.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default FooterItem;



// WEBPACK FOOTER //
// ./src/components/footer-item.jsx